export default {
    intro: `字根是组成单词的最小要素。<br />
            一起来看看由字根组成的单词和字之间的关系吧。`,
    options: { textbook: '课本中的单词', page: '课本' },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `第${round === 1 ? '一' : '二'}个字`;
        },
        title: {
            word: '字', example1: '例词1', example2: '例词2',
            check: '确认学过的单词', question: '单词问题',
            meaning: '确认语义关系', meaningQuestion: '语义关系问题',
        },
    },
    indicator: {
        word: '学习字根的形状、读音和含义。',
        example1: '学习包含字根的两个单词。',
        example2: '了解字根在单词中的用法。',
        question: '两个单词中，使用了"{ reading }"字的单词是哪一个？',
        meaning: '了解字根在单词中的用法。',
        meaningQuestion: '两个字根的语义关系是什么？',
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? '这是学生自己旋转立方体学习的环节。'
                : '自己旋转立方体来学习字吧。';
        },
    },
    result: { correct: '正确', incorrect: '不正确', selected: '已选' },
    buttons: { next: '下一个' },
    study: {
        example: '例句',
        meaning: '含义',
    },
};
